// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_homeimageIcon__dABQ5 {
    display: bloc;
    width: 35%;
    max-width: 32rem;
    min-width: 18rem;
    height: auto;
    margin-right: 4rem;
}

.Home_mainHomeContainer__gLLve {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4vw;
    height: 60vh;
    min-height: calc(100vh - 10rem);
    padding: 3rem 5%;
    box-sizing: border-box;
}

.Home_homeTitle__duF7K h1,
.Home_homeTitle__duF7K span,
.Home_homeTitle__duF7K div {
    color: #2C5C72 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;;IAGI,yBAAyB;AAC7B","sourcesContent":[".homeimageIcon {\n    display: bloc;\n    width: 35%;\n    max-width: 32rem;\n    min-width: 18rem;\n    height: auto;\n    margin-right: 4rem;\n}\n\n.mainHomeContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4vw;\n    height: 60vh;\n    min-height: calc(100vh - 10rem);\n    padding: 3rem 5%;\n    box-sizing: border-box;\n}\n\n.homeTitle :global(h1),\n.homeTitle :global(span),\n.homeTitle :global(div) {\n    color: #2C5C72 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeimageIcon": `Home_homeimageIcon__dABQ5`,
	"mainHomeContainer": `Home_mainHomeContainer__gLLve`,
	"homeTitle": `Home_homeTitle__duF7K`
};
export default ___CSS_LOADER_EXPORT___;
